/*
* @Author: zhangzhitao
* @Date: 2019-04-29 14:24:37
 * @Last Modified by: yuzhou.zhouu
 * @Last Modified time: 2020-04-01 16:09:16
*/

<template>
  <div
    class="page"
    ref="page"
    :style="bgStyle"
  >
    <div
      class="m-board-header"
      v-if="viewInfo.isTitleShow"
    >
      <div class="u-tt">
        {{viewInfo.title}}
      </div>
    </div>
    <canvas
      id="myCanvas"
      class="m-canvas"
    ></canvas>
    <div class="m-widgets-ctn">
      <div
        v-for="(part, i) in arrParts"
        class="m-parts-card"
        :class="{ 'u-parts-sel': activePartsIndex === i,'brand-border-color':activePartsIndex === i }"
        :style="
                `left:${part.xPos}px;top:${part.yPos}px;transform:rotate(${
                  part.type === 'line' || part.type === 'line2' ? part.angle : 0
                }deg);width:${part.width && part.resizable ? part.width + 'px' : 'auto'};height:${part.height && part.resizable ? part.height + 'px': 'auto'};`
              "
        :key="i"
      >
        <div
          class="m-parts-cover"
          @mousemove="drag(i, $event, part)"
          @mouseout="initCursor($event)"
          @click.stop
        ></div>
        <drag-resize
          v-if="part.resizable"
          :left="part.xPos"
          :top="part.yPos"
          :width="part.width"
          :height="part.height"
          @resize="(top,left,width,height) => onWidgetReisze(part,i,top,left,width,height)"
        ></drag-resize>
        <div class="m-widget-container">
          <component
            :is="part.mode"
            :width="part.width"
            :height="part.height"
            v-bind="part.option"
          ></component>
        </div>
        <div
          class="m-config-box"
          :class="{'m-pos-bottom':part.yPos<44}"
          @click.stop
          v-show="activePartsIndex === i"
        >
          <span class="u-config">
            <i>X:</i>
            <el-input
              class="u-ipt"
              v-model.number="xPos"
              v-on:keyup.enter.native="handleEnterKey('x')"
            ></el-input>
          </span>
          <!-- @change="handleChangeXPos" -->
          <span class="u-config">
            <i>Y:</i>
            <el-input
              class="u-ipt"
              v-model.number="yPos"
              v-on:keyup.enter.native="handleEnterKey('y')"
            ></el-input>
          </span>
          <template v-if="part.resizable">
            <span class="u-config">
              <i>{{$t('management.dataView.width')}}:</i>
              <el-input
                class="u-ipt"
                v-model.number="wWidth"
                v-on:keyup.enter.native="handleEnterKey('width')"
              ></el-input>
            </span>
            <span class="u-config">
              <i>{{$t('management.dataView.height')}}:</i>
              <el-input
                class="u-ipt"
                v-model.number="wHeight"
                v-on:keyup.enter.native="handleEnterKey('height')"
              ></el-input>
            </span>
          </template>
          <!-- @change="handleChangeYPos" -->
          <i
            @click="handleRemoveWidget(i)"
            class="u-remove-widget h-icon-delete"
            :title="$t('management.dataView.del_widget')"
          ></i>
          <i
            v-if="part.setting"
            @click="showSettingDialog(part)"
            class="u-remove-widget h-icon-setting"
            style="margin-left: 10px;"
            :title="$t('management.dataView.config_widget')"
          ></i>
        </div>
      </div>
    </div>
    <data-view-setting-dialog
      :visible.sync="settingDialog.show"
      :target="settingDialog.target"
    ></data-view-setting-dialog>
  </div>
</template>

<script>
import dragResize from '@/components/drag-resize/drag-resize'
import dataViewSettingDialog from './data-view-setting-dialog'
export default {
  name: 'data-view-canvas',
  props: {
    arrParts: {
      type: Array,
      default: () => {
        return []
      }
    },
    activePartsIndex: {
      type: Number,
      default: () => {
        return -1
      }
    },
    viewInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    bgStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    maxWidth: {
      type: Number
    },
    maxHeight: {
      type: Number
    }
  },
  watch: {
    activePartsIndex () {
      this.updatePosValue()
    },
    arrParts () {
      this.updatePosValue()
    },
    maxWidth () {
      this.initCanvas()
    },
    maxHeight () {
      this.initCanvas()
    }
  },
  data () {
    return {
      xPos: 0,
      yPos: 0,
      wWidth: 0,
      wHeight: 0,
      settingDialog: {
        show: false,
        target: null
      }
    }
  },

  components: {
    dragResize,
    dataViewSettingDialog
  },

  computed: {},

  mounted () {
    window.onresize = temp => {
      this.initCanvas()
    }
    this.initCanvas()
  },

  methods: {
    // 当配置的小部件数组发生变化的时候，修改当前选中项的位置值
    updatePosValue () {
      if (!this.arrParts.length || this.activePartsIndex < 0) return
      let _part = this.arrParts[this.activePartsIndex]
      this.xPos = _part.xPos
      this.yPos = _part.yPos
      this.wWidth = _part.width
      this.wHeight = _part.height
    },
    // 按回车时才触发坐标值变化
    handleEnterKey (type) {
      let Dom = document.getElementsByClassName('m-parts-cover')[this.activePartsIndex]
      let widgetWidth = Dom.offsetWidth
      let widgetHeight = Dom.offsetHeight
      if (type === 'x') {
        let value = !this.xPos || isNaN(parseInt(this.xPos)) ? 0 : parseInt(this.xPos)
        this.arrParts[this.activePartsIndex].xPos = value < 0 ? 0 : (value + widgetWidth) > this.maxWidth ? (this.maxWidth - widgetWidth) : value
      } else if (type === 'y') {
        let value = !this.yPos || isNaN(parseInt(this.yPos)) ? 0 : parseInt(this.yPos)
        this.arrParts[this.activePartsIndex].yPos = value < 0 ? 0 : (value + widgetHeight) > this.maxHeight ? (this.maxHeight - widgetHeight) : value
      } else if (type === 'width') {
        let value = !this.wWidth || isNaN(parseInt(this.wWidth)) ? 0 : parseInt(this.wWidth)
        this.arrParts[this.activePartsIndex].width = value
      } else if (type === 'height') {
        let value = !this.wHeight || isNaN(parseInt(this.wHeight)) ? 0 : parseInt(this.wHeight)
        this.arrParts[this.activePartsIndex].height = value
      }
    },
    handleChangeXPos (val) {
      let value = !val || isNaN(parseInt(val)) ? 0 : parseInt(val)
      let Dom = document.getElementsByClassName('m-parts-cover')[this.activePartsIndex]
      let widgetWidth = Dom.offsetWidth
      this.arrParts[this.activePartsIndex].xPos = value < 0 ? 0 : (value + widgetWidth) > this.maxWidth ? (this.maxWidth - widgetWidth) : value
    },
    handleChangeYPos (val) {
      let value = !val || isNaN(parseInt(val)) ? 0 : parseInt(val)
      let Dom = document.getElementsByClassName('m-parts-cover')[this.activePartsIndex]
      let widgetHeight = Dom.offsetHeight
      this.arrParts[this.activePartsIndex].yPos = value < 0 ? 0 : (value + widgetHeight) > this.maxHeight ? (this.maxHeight - widgetHeight) : value
    },
    // canvas画格子
    initCanvas () {
      let cas = document.getElementById('myCanvas')
      let ctx = cas.getContext('2d')
      this.winSize = {
        w: this.$refs.page.offsetWidth,
        h: this.$refs.page.offsetHeight
      }
      let pageW = this.$refs.page.offsetWidth
      let pageH = this.$refs.page.offsetHeight
      cas.width = pageW
      cas.height = pageH
      ctx.strokeStyle = 'rgba(0,0,0,0.1)'
      ctx.lineWidth = 1
      for (let i = 0; i < pageW / 10; i++) {
        ctx.beginPath()
        ctx.moveTo(i * 10 + 0.5, 0)
        ctx.lineTo(i * 10 + 0.5, pageH)
        ctx.stroke()
      }
      for (let i = 0; i < pageH / 10; i++) {
        ctx.beginPath()
        ctx.moveTo(0, i * 10 + 0.5)
        ctx.lineTo(pageW, i * 10 + 0.5)
        ctx.stroke()
      }
    },
    // 编辑区域内，调整部件大小及位置
    drag (index, e, widget) {
      let el = e.target
      // 鼠标点中要改变的部件
      el.onmousedown = e => {
        if (widget.type !== 'line') {
          widget['width'] = e.target.offsetWidth
          widget['height'] = e.target.offsetHeight
        }
        this.$emit('choose', index)
        // 获取鼠标点下时，鼠标的位置
        let startX = e.clientX
        let startY = e.clientY
        this.xPos = widget.xPos
        this.yPos = widget.yPos
        // 深拷贝，记录部件初始大小及位置
        let Parts = JSON.parse(JSON.stringify(widget))
        // 鼠标按住不松开，进行移动
        document.onmousemove = e => {
          let midX = e.clientX
          let midY = e.clientY
          let diffX = midX - startX
          let diffY = midY - startY
          widget.xPos = Parts.xPos + diffX
          widget.yPos = Parts.yPos + diffY
          this.xPos = widget.xPos
          this.yPos = widget.yPos
          // 鼠标松开，确定部件最终位置
          document.onmouseup = e => {
            widget.xPos = widget.xPos < 0 ? 0 : (widget.xPos + widget.width) > this.maxWidth ? (this.maxWidth - widget.width) : widget.xPos
            widget.yPos = widget.yPos < 0 ? 0 : (widget.yPos + widget.height) > this.maxHeight ? (this.maxHeight - widget.height) : widget.yPos
            this.xPos = widget.xPos
            this.yPos = widget.yPos
            document.onmousemove = null // 释放全局捕获
            document.onmouseup = null
            document.onmousedown = null
          }
        }
        document.onmouseup = e => {
          document.onmousemove = null // 释放全局捕获
          document.onmouseup = null
          document.onmousedown = null
          el.style.cursor = 'default'
        }
      }
    },
    // 初始化指针
    initCursor (e) {
      let el = e.target.parentNode
      el.style.cursor = 'default'
    },
    // 移除部件
    handleRemoveWidget (i) {
      this.$emit('remove', i)
    },
    onWidgetReisze (part, index, top, left, width, height) {
      part.xPos = left
      part.yPos = top
      part.width = width
      part.height = height
      if (this.activePartsIndex === index) {
        this.xPos = left
        this.yPos = top
        this.wWidth = width
        this.wHeight = height
      }
    },
    // 展示配置属性的对话框
    showSettingDialog (part) {
      if (!part.setting) return
      this.settingDialog.target = part
      this.settingDialog.show = true
    }
  }
}

</script>

<style lang="less" scoped>
.page {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
  .m-board-header {
    position: absolute;
    left: 50%;
    margin-left: -755px;
    top: 0;
    width: 1511px;
    height: 101px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    z-index: 1;
    background-image: url("../../../../assets/images/kanban-header.png");

    .u-tt {
      position: absolute;
      left: 50%;
      margin-left: -343px;
      width: 686px;
      height: 74px;
      line-height: 74px;
      letter-spacing: 2px;
      text-align: center;
      font-size: 32px;
      color: #c7dfff;
      font-weight: bold;
      overflow: hidden;
      user-select: none;
    }
  }
  .m-canvas {
    position: absolute;
    background: transparent;
    z-index: 0;
  }
  .m-widgets-ctn {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    .u-comp-outer {
      position: absolute;
      border: 1px solid transparent;
      .u-comp-cover {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 10;
      }
      .u-comp {
        user-select: none;
        z-index: 9;
      }
    }
    .u-comp-sel {
      border-color: aqua;
    }
    .m-parts-card {
      position: absolute;
      border: 2px solid transparent;
      z-index: 1;
      box-sizing: content-box;
      .m-widget-container {
        height: 100%;
        width: 100%;
        overflow: auto;
      }
      .m-config-box {
        position: absolute;
        right: 0;
        top: -38px;
        // width: 230px;
        height: 32px;
        background: #fff;
        border-radius: 2px;
        line-height: 32px;
        padding: 0 4px 0 12px;
        box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2),
          0 2px 4px 0 rgba(0, 0, 0, 0.12);
        display: flex;
        &.m-pos-bottom {
          top: auto;
          bottom: -38px;
        }
        .u-config {
          // float: left;
          margin-right: 12px;
          display: flex;
          align-items: center;
          i {
            margin-right: 8px;
            white-space: nowrap;
          }
          .u-ipt {
            width: 64px;
            height: 20px;
            display: flex;
            align-items: center;
            /deep/ .el-input__inner {
              height: 20px;
              font-size: 12px;
              background: rgba(0, 0, 0, 0.04);
              border: none;
            }
          }
        }

        .u-remove-widget {
          // float: right;
          position: relative;
          font-size: 24px;
          margin-top: 4px;
          margin-bottom: 4px;
          margin-left: 6px;
          cursor: pointer;
          &:hover {
            background: rgba(0, 0, 0, 0.06);
          }
          &::after {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            left: -6px;
            width: 1px;
            height: 24px;
            background: rgba(0, 0, 0, 0.12);
          }
        }
      }
      .m-parts-cover {
        position: absolute;
        left: 0px;
        top: 0px;
        bottom: 0px;
        right: 0px;
        z-index: 6;
      }
      .m-parts-cover:hover {
        cursor: move;
      }
      .m-line {
        width: 300px;
        height: 10px;
        overflow: hidden;
        .u-line-start {
          float: left;
          width: 61px;
          height: 10px;
          background-position: center;
          background-repeat: no-repeat;
        }
        .u-line-repeat {
          float: left;
          width: calc(~"100% - 119px");
          height: 10px;
          background-position: center;
          background-repeat: repeat-x;
        }
        .u-line-end2 {
          float: left;
          width: 58px;
          height: 10px;
          background-position: center;
          background-repeat: no-repeat;
        }
        .u-line-end {
          float: left;
          width: 58px;
          height: 10px;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .u-parts-head {
        width: 100%;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        text-indent: 10px;
        box-sizing: border-box;
        color: #4c4c4c;
        .u-more {
          float: right;
          margin-right: 10px;
          font-size: 12px;
          color: #7f7f7f;
        }
      }
      .u-widget {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .u-widget-showbar {
        height: calc(~"100% - 40px");
      }
      .u-del-parts {
        position: absolute;
        right: -25px;
        top: 0;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        font-size: 10px;
        color: #fff;
        background: #d8d8d8;
        cursor: pointer !important;
        z-index: -1;
      }
    }

    .m-parts-card.u-parts-sel {
      z-index: 2;
    }
  }
}
</style>
